import { Injectable } from '@angular/core';
import { OccProductAvailabilityResponse } from '@availability/const';
import { AvailabilityActions, OccAvailabilityService } from '@availability/data-access';
import { CustomActiveCartService } from '@cart/data-access';
import { CityActions } from '@city/data-access';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of, switchMap } from 'rxjs';
import { catchError, distinctUntilChanged, map, mergeMap, take } from 'rxjs/operators';

@Injectable()
export class AvailabilityEffects {
  load$: Observable<AvailabilityActions.LoadAvailabilitySuccess | AvailabilityActions.LoadAvailabilityFail> =
    createEffect(() =>
      this.actions$.pipe(
        ofType(AvailabilityActions.LOAD_AVAILABILITY),
        mergeMap((action: AvailabilityActions.LoadAvailability) => {
          const { productCode, unitCode, quantity } = action;

          return this.activeCartService.getActiveCartId().pipe(
            take(1),
            switchMap((cartId: string) => {
              return this.occAvailabilityService.loadAvailability(productCode, unitCode, quantity, cartId).pipe(
                map(
                  ({ stockLevel, deliveryDate, unit, forceInStock, price }: OccProductAvailabilityResponse) =>
                    new AvailabilityActions.LoadAvailabilitySuccess(productCode, unitCode, quantity, {
                      quantity,
                      deliveryDate,
                      stockLevel,
                      unit,
                      forceInStock,
                      price,
                    }),
                ),
                catchError((e: unknown) =>
                  of(new AvailabilityActions.LoadAvailabilityFail(productCode, unitCode, quantity, e)),
                ),
              );
            }),
          );
        }),
      ),
    );

  changeBaseStore$: Observable<AvailabilityActions.ResetAvailability> = createEffect(() =>
    this.actions$.pipe(
      ofType(CityActions.SET_ACTIVE_BASE_STORE),
      map(({ payload }) => payload),
      distinctUntilChanged(),
      map(() => new AvailabilityActions.ResetAvailability()),
    ),
  );

  constructor(
    private actions$: Actions,
    private occAvailabilityService: OccAvailabilityService,
    private activeCartService: CustomActiveCartService,
  ) {}
}
